export function initBannerImage() {
	const bannerContainer = document.getElementById("banner-image-container");
	if (!bannerContainer) return;

	const imgUrl = bannerContainer.getAttribute("data-url");
	const overlay = bannerContainer.getAttribute("data-overlay") === "true";

	if (!imgUrl) return;

	const overlayCss = overlay
		? "linear-gradient(45deg, rgba(63,71,82,0.8) 0%, rgba(63,71,82,0) 100%), "
		: "";

	// Use jQuery if available, fallback to vanilla
	if (window.jQuery) {
		window.jQuery(".ituBanner").css({
			"background-image": `${overlayCss}url("${imgUrl}")`,
			"background-size": "cover",
			"background-position": "center",
			"background-repeat": "no-repeat",
		});
	} else {
		const banner = document.querySelector(".ituBanner");
		if (banner) {
			banner.style.backgroundImage = `${overlayCss}url("${imgUrl}")`;
			banner.style.backgroundSize = "cover";
			banner.style.backgroundPosition = "center";
			banner.style.backgroundRepeat = "no-repeat";
		}
	}
}
